// removed by extract-text-webpack-plugin
module.exports = {"card":"card__3w4ge","no_margin":"no_margin__usJic","card_title":"card_title__34Hvg","card_title_large":"card_title_large__1_ALn"};


//////////////////
// WEBPACK FOOTER
// ./components/card/style.scss
// module id = wGJf
// module chunks = 13